import type { RootState } from "..";

export const selectClients = (state: RootState) => state.app.clients;

export const selectClient = (state: RootState) => state.app.client;

export const selectClientMeteringPoints = (state: RootState) =>
  state.app.clientMeteringPoints;

export const selectUsers = (state: RootState) => state.app.users;

export const selectUser = (state: RootState) => state.app.user;

export const selectOperators = (state: RootState) => state.app.operators;

export const selectMeteringPoints = (state: RootState) =>
  state.app.meteringPoints;

export const selectContracts = (state: RootState) => state.app.contracts;

export const selectReportsQueryOptions = (state: RootState) =>
  state.app.reportsQueryOptions;

export const selectReportsQueries = (state: RootState) =>
  state.app.reportsQueries;

export const selectForecastTemplates = (state: RootState) =>
  state.app.forecastTemplates;

export const selectForecasts = (state: RootState) => state.app.forecasts;

export const selectForecast = (state: RootState) => state.app.forecast;

export const selectProductionParks = (state: RootState) =>
  state.app.productionParks;

export const selectProductionPark = (state: RootState) =>
  state.app.productionPark;

export const selectProductionParkComponents = (state: RootState) =>
  state.app.productionParkComponents;

export const selectProductionParkComponent = (state: RootState) =>
  state.app.productionParkComponent;

export const selectProductionForecasts = (state: RootState) =>
  state.app.productionForecasts;
export const selectProductionForecast = (state: RootState) =>
  state.app.productionForecast;
export const selectProductionForecastSelect = (state: RootState) =>
  state.app.productionForecastSelect;

export const selectForecaCoefficents = (state: RootState) =>
  state.app.forecaCoefficients;

export const selectMe = (state: RootState) => state.app.me;

export const selectCurrentRoleClientId = (state: RootState) =>
  state.app.currentRoleClientId;

export const selectInvites = (state: RootState) => state.app.invites;

export const selectSupplyPlanForecast = (state: RootState) =>
  state.app.supplyPlanForecast;

export const selectClientSupplyPlanForecast = (state: RootState) =>
  state.app.clientSupplyPlanForecast;

export const selectSupplyPlanPriceLimits = (state: RootState) =>
  state.app.supplyPlanPriceLimits;

export const selectClientSupplyPlanPriceLimits = (state: RootState) =>
  state.app.clientSupplyPlanPriceLimits;

export const selectBaseLoads = (state: RootState) => state.app.baseLoads;

export const selectSupplyPlanScheduled = (state: RootState) =>
  state.app.supplyPlanScheduled;

export const selectLitgridLogs = (state: RootState) => state.app.litgridLogs;

export const selectProductionForecastGroups = (state: RootState) =>
  state.app.productionForecastGroups;

export const selectProductionForecastGroup = (state: RootState) =>
  state.app.productionForecastGroup;

export const selectProductionForecastNew = (state: RootState) =>
  state.app.productionForecastNew;

export const selectFRRBids = (state: RootState) => state.app.frrBids;

export const selectProductionParkLimitations = (state: RootState) =>
  state.app.productionParkLimitations;

export const selectPortfolios = (state: RootState) => state.app.portfolios;

export const selectPortfolio = (state: RootState) => state.app.portfolio;

export const selectPortfolioPriceLimits = (state: RootState) =>
  state.app.portfolioPriceLimits;

export const selectNordPoolSupplyPlans = (state: RootState) =>
  state.app.nordPoolSupplyPlans;

export const selectNordPoolSupplyPlan = (state: RootState) =>
  state.app.nordPoolSupplyPlan;

export const selectNordPoolPriceSteps = (state: RootState) =>
  state.app.nordPoolPriceSteps;

export const selectPortfolioContracts = (state: RootState) =>
  state.app.portfolioContracts;

export const selectClientGOSettings = (state: RootState) =>
  state.app.clientGOSettings;

export const selectGOCertificates = (state: RootState) =>
  state.app.GOCertificates;

export const selectGOGroups = (state: RootState) => state.app.GOGroups;

export const selectGOYearlySummary = (state: RootState) =>
  state.app.GOYearlySummary;

export const selectGOSummary = (state: RootState) => state.app.GOSummary;

export const selectBatteryGroups = (state: RootState) =>
  state.app.batteryGroups;

export const selectBatteryGroup = (state: RootState) =>
  state.app.batteryGroup;

export const selectBatteries = (state: RootState) => state.app.batteries;

export const selectBattery = (state: RootState) => state.app.battery;

export const selectLastGoSyncTime = (state: RootState) =>
  state.app.lastGoSyncTime;

export const selectGOActiveClients = (state: RootState) =>
  state.app.GOActiveClients;

export const selectBalancePlans = (state: RootState) =>
  state.app.balancePlans;
